import {Component, OnDestroy, OnInit} from '@angular/core';
import {Group, Rule, Source} from "app/models/group_ref.model";
import {GroupRefService} from "./group_ref.service";
import {ConfirmComponent} from "app/views/modal/confirm.component";
import {PromptComponent} from "app/views/modal/prompt.component";
import {AlertComponent} from "app/views/modal/alert.component";
import {TranslateService} from "app/translate/translate.service";
import { Subscription } from 'rxjs';
import {ModalService} from "app/views/modal/base_modal.component";


function checkName(name:string): boolean {
	return /^[a-z-A-Z0-9]{2,}$/.test(name);
}

@Component({
	selector: 'group-ref',
	templateUrl: './group_ref.component.html'
})
export class GroupRefComponent implements OnInit, OnDestroy {
	groupsBusy: Subscription;
	sourcesBusy: Subscription;
	rulesBusy: Subscription[] = [];
	previewRules: Rule[] = [];

	public checkInterval: any = null;
	public groups: Group[] = [];
	public sources: Source[] = [];
	public currentGroup: Group;
	public groupsSortOptions: any;
	public sourcesSortOptions: any;
	public rebuilding = {status: false, procent: 0, dateStart: ''};

	constructor(
		private groupRefService: GroupRefService,
		private modalService: ModalService,
		private _translate: TranslateService,
	) {
		this.groupsSortOptions = {
			onUpdate: event => {
				this.groups.forEach(function (group, i) {
					group.priority = i;
				});

				this.groupRefService.sortGroups(this.groups).subscribe(data => {
					console.log(data);
				});
			}
		};

		this.sourcesSortOptions = {
			onUpdate: event => {
				this.sources.forEach(function (source, i) {
					source.priority = i;
				});

				this.groupRefService.sortSources(this.sources).subscribe(data => {
					console.log(data);
				});
			}
		};
	}
	
	
	handleError(error) {
		if (error == '500 - Internal Server Error referer rebuilding is active!') {
			this.modalService.open(AlertComponent, {
				title: 'Внимание!',
				message: 'В данный момент запущено перестроение рефереров! Вы не можете вносить изменения.'
			});

			this.rebuilding = {
				status: true,
				procent: 1,
				dateStart: ''
			};
		}
	}
	
	
	getGroups() {
		this.groupsBusy = this.groupRefService.getGroups()
			.subscribe(
				(groups: Group[]) => this.groups = groups,
				this.handleError
			);
	}
	
	ngOnInit() {
		this.clearInterval();
		
		this.checkInterval = setInterval(() => {
			this.groupRefService.getStatus()
				.subscribe((data: any) => {
					if (data.isActive == 0) {
						this.rebuilding = {
							status: false,
							procent: 0,
							dateStart: ''
						};
						
						return ;
					}
					
					this.rebuilding = {
						status: data.isActive,
						procent: data.procent,
						dateStart: data.dateStart
					};
				});
		}, 30 * 1000);
		
		if (this.rebuilding.status === false) {
			this.getGroups();
		}
	}
	
	clearInterval() {
		if (this.checkInterval) {
			clearInterval(this.checkInterval);
		}
	}
	
	ngOnDestroy() {
		this.clearInterval();
	}
	
	
	editGroup(id: number) {
		
		// Нужно добавить проверку на бэкенде, что группа с таким названием уже есть
		const
			me = this,
			group = this.groups.find(g => g.id === id);

		const r = this.modalService.open(PromptComponent, {
			title: this._translate.instant('adminstat.users.group_ref_new.group editing'),
			question: this._translate.instant('adminstat.users.group_ref_new.enter new group name'),
			message: group.name
		});
		
		
		// Что тут блять твориться? Добавил заглушку для отмены
		r.result.then(function (newGropName: string) {
			if (newGropName === 'cancel') {
				return;
			}
			
			if ( ! checkName(newGropName)) {
				me.modalService.open(AlertComponent, {
					title: 'Имя должно состоять из латинских букв и цифр',
					message: 'Например "NewCampaign"'
				});
				
				return ;
			}

			newGropName = newGropName.replace(/"/g, '');
			
			me.groupRefService.renameGroup(id, newGropName).subscribe((data: any) => {
				console.log(data);
			});
			
			me.groups.forEach(function (group) {
				if (group.id == id) {
					group.name = newGropName;
				}
			});
		});
	}

	deleteGroup(id: number) {
		let me = this;
		let r = this.modalService.open(ConfirmComponent, {
			title: this._translate.instant('adminstat.users.group_ref_new.group deleting'),
			message: this._translate.instant('adminstat.users.group_ref_new.want delete group')
		});

		r.result.then(function (isConfirmed:any) {
			if (isConfirmed === true) {
				me.groupRefService.deleteGroup(id).subscribe((data: any) => {
					console.log(data);
				});

				me.groups = me.groups.filter(function (group) {
					return group.id != id;
				});
			}
		});
	}

	deleteSource(id: number, index: number) {
		if (id == 0) {
			this.sources.splice(index, 1);
		} else {
			let me = this;
			let r = this.modalService.open(ConfirmComponent, {
				title: this._translate.instant('adminstat.users.group_ref_new.source deleting'),
				message: this._translate.instant('adminstat.users.group_ref_new.want delete source')
			});

			r.result.then(function (isConfirmed:any) {
				if (isConfirmed === true) {
					me.groupRefService.deleteSource(id).subscribe((data: any) => {
						console.log(data);
					});

					me.sources = me.sources.filter(function(source) {
						return source.id != id;
					});
				}
			});
		}
	}

	loadSource(index: number) {
		this.previewRules = [];

		this.rulesBusy[index] = this.groupRefService.getRules(
			this.sources[index].groupId,
			this.sources[index].id
		).subscribe((rules: Rule[]) => {
			this.sources[index].rules = rules;

			this.previewRules = rules;
		});
	}

	editSource(index: number) {
		this.sources[index].isSourceEdit = !this.sources[index].isSourceEdit;

		this.loadSource(index);
	}

	addGroup() {
		// Нужно добавить проверку на бэкенде, что группа с таким названием уже есть
		let me = this;
		let r = this.modalService.open(PromptComponent, {
			title: this._translate.instant('adminstat.users.group_ref_new.group adding'),
			question: this._translate.instant('adminstat.users.group_ref_new.enter add group name'),
			//pattern: '^(a-z-A-Z0-9){2,}'
		});
		
		r.result.then(function (res:string) {
			// if (res && res.length > 2) {
			if ( ! checkName(res)) {
				me.modalService.open(AlertComponent, {
					title: 'Имя должно состоять из латинских букв и цифр',
					message: 'Например "NewCampaign"'
				});
				
				return ;
			}
			
			res = res.replace(/"/g, '');
			
			me.groupsBusy = me.groupRefService.addGroup(res).subscribe((data: any) => {
				console.log(data);
				
				me.groups.push({
					id: data[1].insertId,
					name: res,
					priority: 0
				});
			});
		});
	}

	addSource() {
		const rule = new Rule();
		rule.filter = 'utm_source';
		rule.state = 'equal';
		rule.text = `${this.currentGroup.name} source`;
		
		this.sources.push({
			id: 0,
			name: `${this.currentGroup.name} source`,
			priority: 0,
			groupId: this.currentGroup.id,
			isSourceEdit: true,
			rules: [rule]
		});
	}

	saveSource(id: number, sourceIndex: number) {
		if (this.sources[sourceIndex].name == '') {
			this.modalService.open(AlertComponent, {
				title: this._translate.instant('adminstat.users.group_ref_new.save source'),
				message: this._translate.instant('adminstat.users.group_ref_new.enter title first')
			});
			return true;
		}

		let me = this;
		let r = this.modalService.open(ConfirmComponent, {
			title: this._translate.instant('adminstat.users.group_ref_new.save source'),
			message: this._translate.instant('adminstat.users.group_ref_new.want save rule')
		});

		r.result.then(function (isConfirmed: any) {
			if (isConfirmed === true) {
				// Поиск пустых правил
				let emptyRules = 0;
				me.sources[sourceIndex].rules.forEach(function (rule) {
					if (rule.filter == '' && rule.state == '' && rule.text == '') {
					// if ( ! (rule.filter && rule.state && rule.text)) {
						emptyRules++;
					}
				});
				console.log('emptyRules', emptyRules)
				if (emptyRules > 0) {
					me.modalService.open(AlertComponent, {
						title: me._translate.instant('adminstat.users.group_ref_new.save source'),
						message: me._translate.instant('adminstat.users.group_ref_new.one of rules is empty')
					});
					return true;
				}

				if (me.sources[sourceIndex].id == 0) {
					// Если этот источник еще не сохранен, то добавить его в базу
					me.rulesBusy[sourceIndex] = me.groupRefService.saveSource(me.sources[sourceIndex]).subscribe((data: any) => {
						me.sources[sourceIndex].id = data[1].id;
						me.sources[sourceIndex].isSourceEdit = false;
					});
				} else {
					// В противном случае просто обновить
					me.rulesBusy[sourceIndex] = me.groupRefService.editSource(me.sources[sourceIndex]).subscribe((data: any) => {
						me.sources[sourceIndex].isSourceEdit = false;
					});
				}

			}
		});
	}

	openGroup(id: number) {
		const me = this;

		me.currentGroup = this.groups.find(group => group.id == id);

		me.sources = [];

		me.sourcesBusy = me.groupRefService.getSources(
			me.currentGroup.id
		).subscribe((sources: Source[]) => {
			me.sources = sources;
		});
	}

	deleteRule(ruleIndex: number, sourceIndex: number) {
		var rules = this.sources[sourceIndex].rules;

		if (rules.length == 1) {
			this.modalService.open(AlertComponent, {
				title: this._translate.instant('adminstat.users.group_ref_new.deleting rule'),
				message: this._translate.instant('adminstat.users.group_ref_new.can not delete last rule')
			});
		} else {
			var rule = rules[ruleIndex],
				exprId = rule.exprId,
				exprStart = rule.exprStart,
				exprEnd = rule.exprEnd,
				length = 0;
			
			rules.splice(ruleIndex, 1);
			
			// Проверки для OR правил
			if (exprId != 0 && (exprStart || exprEnd)) {

				// Узнать количество правил с таким же exprId
				for (let i = 0; i < rules.length; i++) {
					if (exprId == rules[i].exprId) length++;
				}

				// Если осталось только одно правило OR, то превратить его в AND
				if (length == 1) {
					for (let i = 0; i < rules.length; i++) {
						if (exprId == rules[i].exprId) {
							rules[i].isExpr = false;
							rules[i].exprStart = false;
							rules[i].exprEnd = false;
							rules[i].exprId = 0;
						}
					}
				} else {
					// Если было удалено первое правило из подгруппы, то обновить exprStart
					if (exprStart == true) {
						for (let i = 0; i < rules.length; i++) {
							if (exprId == rules[i].exprId) {
								rules[i].exprStart = true;
								rules[i].exprEnd = false;
								break;
							}
						}
					}

					// Если было удалено последнее правило из подгруппы, то обновить exprEnd
					if (exprEnd == true) {
						for (let i = rules.length - 1; i >= 0; i--) {
							if (exprId == rules[i].exprId) {
								rules[i].exprStart = false;
								rules[i].exprEnd = true;
								break;
							}
						}
					}
				}
			}
		}
	}

	addRule(cond: string, ruleIndex: number, sourceIndex: number) {
		if (this.sources[sourceIndex].rules.length > 9) {
			this.modalService.open(AlertComponent, {
				title: this._translate.instant('adminstat.users.group_ref_new.adding rule'),
				message: this._translate.instant('adminstat.users.group_ref_new.max 10 rules')
			});
			return true;
		}

		var rules = this.sources[sourceIndex].rules;

		if (cond == 'and') {
			rules.splice(ruleIndex + 1, 0, {
				filter: '',
				state: '',
				text: '',
				isExpr: false,
				exprId: 0,
				exprStart: false,
				exprEnd: false
			});
		} else if (cond == 'or') {
			var rule = this.sources[sourceIndex].rules[ruleIndex],
				exprId = 0,
				exprStart = false,
				exprEnd = false;

			if (rule.exprId != 0) {
				// Добавить or к уже существующему
				exprId = rule.exprId;
				exprStart = false;
				exprEnd = true;
			} else {
				// Найти максимальный exprId
				let max = 0;
				rules.forEach(function (rule) {
					if (rule.exprId > max) max = rule.exprId;
				});

				exprId = max + 1;
				exprStart = false;
				exprEnd = true;
			}

			if (rule.isExpr == false) {
				rule.isExpr = true;
				rule.exprId = exprId;
				rule.exprStart = true;
			}

			rule.exprEnd = false;

			rules.splice(ruleIndex + 1, 0, {
				filter: '',
				state: '',
				text: '',
				isExpr: true,
				exprId: exprId,
				exprStart: exprStart,
				exprEnd: exprEnd
			});
		}
	}
	
	
	async rebuild() {
		const me = this;
		
		const r = await me.groupRefService.rebuild().toPromise();
		console.log('r', r)
	}
}
